<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_showUser">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["AN"]["VSAD"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_showUser = !bool_showUser">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage['AN']['AT']}} :</label>
                                            <CInput vertical size="sm" :value="str_title" :disabled="true" />
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol>
                                            <label class="col-form-label-sm">{{this.getLanguage['AN']['AC']}} :</label>
                                            <textarea vertical="" rows="10" class="form-control form-control-sm" :value="str_content" :disabled="true" />
                                        </CCol>
                                    </CRow>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["AN"]["AA"]}}</h2>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="/src/assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["AN"]["ATC"]}} :</span>
                                <CInput size="sm"
                                        :value="searchATC" :placeholder="getLanguage['AN']['SH']"
                                        @change="v => searchATC = v" />
                            </div>

                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" ref="search" class='searchBtn' size="sm" block color="success" @click=" newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
        </div>

        <div class="container-fluid">
            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{this.getLanguage["AN"]["AAL"]}}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>


                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th class="text-center">{{this.getLanguage["GL"]["NO"]}}</th>
                                <th>{{this.getLanguage["AN"]["AT"]}}</th>
                                <th class="text-center">{{this.getLanguage["AN"]["S"]}} {{this.getLanguage["AN"]["GMT8"]}}</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th class="text-center" width="60px">{{this.getLanguage["GL"]["NO"]}}</th>
                                <th>{{this.getLanguage["AN"]["AT"]}}</th>
                                <th class="text-center" width="250px">{{this.getLanguage["AN"]["S"]}} {{this.getLanguage["AN"]["GMT8"]}}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_san.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_san" :class="renderStatus(data.status)">
                            <td class="text-center">
                                <div class="no-list">
                                    {{ CountItem(index+1) }}
                                    <div v-if="getUserInfo.AT == 0 && !data.PTS">
                                        <img src="/src/assets/icons/un-pin.svg" class="pin-icon ml-3 pointer" @click="pinItem(data)" alt="unpinned">
                                    </div>
                                    <div v-else-if="getUserInfo.AT == 0">
                                        <img src="/src/assets/icons/pin.svg" class="pin-icon ml-3 pointer" @click="pinItem(data)" alt="pinned">
                                    </div>
                                </div>
                            </td>
                            <td class="white-spaceUnset pointer" @click="showUser(data.ACT,data.AC)">
                                <span class="ann-underline ann-green-bold">{{ data.ACT }}</span>
                                <p></p>
                                <p>{{ substrContent(data.AC, 130) }}</p>
                            </td>
                            <td class="font12">
                                <br>
                                <span v-if="data.MSTS != null">{{getLanguage["GL"]["FR"]}}: <span class="floatRight ann-blue bold">{{ formatDateTime(data.MSTS, "YYYY-MM-DD HH:mm:ss", "ddd, DD MMM YYYY HH:mm:ss") }}</span></span>
                                <span v-else-if="data.HS == false">{{getLanguage["GL"]["FR"]}}: <span class="floatRight ann-blue bold">{{ formatDateTime(data.UTS, "YYYY-MM-DD HH:mm:ss", "ddd, DD MMM YYYY HH:mm:ss") }}</span></span>
                                <span v-else>{{getLanguage["GL"]["FR"]}}: <span class="floatRight ann-blue bold">{{ formatDateTime(data.STS, "YYYY-MM-DD HH:mm:ss", "ddd, DD MMM YYYY HH:mm:ss") }}</span></span>
                                <br>
                                <span v-if="data.METS != null">{{getLanguage["AN"]["UT"]}}: <span class="floatRight ann-blue bold">{{ formatDateTime(data.METS, "YYYY-MM-DD HH:mm:ss", "ddd, DD MMM YYYY HH:mm:ss") }}</span></span>
                                <span v-else-if="data.HS == false">{{getLanguage["AN"]["UT"]}}: <span class="floatRight ann-red bold">{{getLanguage["AN"]["IN"]}}</span></span>
                                <span v-else>{{getLanguage["AN"]["UT"]}}: <span class="floatRight ann-blue bold">{{ formatDateTime(data.ETS, "YYYY-MM-DD HH:mm:ss", "ddd, DD MMM YYYY HH:mm:ss") }}</span></span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import { mapGetters, mapActions } from 'vuex'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Loading from 'vue-loading-overlay';
    import { required } from 'vuelidate/lib/validators'
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import $ from 'jquery'

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            Loading
        },
        data() {
            return {
                bool_CV: false, // Check Validation
                bool_isAMV: false, // Add Modal Visible
                bool_fullLoading: false, //Loading Visible
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showUser: false,
                bool_showSearchBar: true,
                str_title: "",
                str_content: "",
                arry_userList: [],
                int_TI: 0,//Total Items
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "R", //(sort the table col name)
                bool_isSort: false,
                bool_SentAll: false,
                searchATC: "", //Filter Value
                arry_san: [], //system annoucement list
                constAccessType: constAccessType,
                dateTS: {
                    startDate: this.getTodayDate(),
                    endDate: this.getTodayEndDate()
                }
            }
        },
        created() {
            this.$parent.showSubMenu = 'DASH';
            this.$parent.showActiveMenu = 'DASH.AA';
            if (this.$route.path == '/AN/AA') {
                this.$parent.showSubMenu = 'AN';
                this.$parent.showActiveMenu = 'AN.AA';
            }

            this.searchATC = this.$route.query.fr;
            window.addEventListener("resize", this.resizeTableHead);
            this.getSANList();

            window.addEventListener("resize", this.resizeTableHead);
        },
        computed: {
            ...mapGetters('Language', ['getLanguage', "getLangCode"]),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
        },
        methods: {
            showUser(title, content) {
                this.bool_showUser = true;
                this.str_title = title;
                this.str_content = content;
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('DASH', 'AA', type);
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getSANList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getSANList();
                }
            },
            getSANList() {
                this.bool_fullLoading = true;
                var that = this;
                var currentLang = this.getLangCode;  //set current language, display EN for default

                var sts_to = moment(this.getTodayDate()).format("YYYY-MM-DD") + "T00:00:00";
                var ets_from = moment(this.getTodayDate()).format("YYYY-MM-DD") + "T23:59:59";
                var now = moment().format("YYYY-MM-DDTHH:mm:ss");
                var path = `p=${this.int_Page}&n=${this.int_RC}&s=STS&d=true&f[L_csv]=${currentLang}&f[STS_to]=${now}&f[ETS_from]=${now}`;

                if (this.searchATC != null && this.searchATC != "") {
                    path += `&f[ATC]=${this.searchATC}`
                }

                this.getDataApi(`/api/aann/laann?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setSANList(d.D);
                            that.resizeTableHead();
                        }
                    });
            },
            setSANList(data) {
                this.arry_san = data.Items;
                this.int_TP = Math.max(data.TotalPages, 1);
                this.int_TI = data.TotalItems;
            },
            renderStatus(index) {

                if (index) {
                    return "ActiveAnn-row";
                } else {
                    return "";
                }

            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
                this.getSANList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            pinItem(data) {
                this.bool_fullLoading = true;
                var that = this;

                // Make a POST request to the API
                this.postDataApi(`/api/aann/pin`, data, (d, s) => {
                    // Reset loading state
                    that.bool_fullLoading = false;

                    if (s) {
                        // If successful, update SAN list and show success message
                        that.getSANList();
                        that.showSuccessMessage(
                            that.utilGetErrorLanguage("ERR.SS"),
                            that.utilGetErrorLanguage("GL.AS")
                        );
                    }
                });
            },
        },
        watch: {
            getLanguage() {
                this.getSANList();
            },
        }
    }

</script>
<style>
    .noWarp {
        overflow-wrap: break-word !important;
        white-space: pre-line !important;
        width: 100% !important;
    }

    .floatRight {
        float: right;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        position: -webkit-sticky;
        position: sticky;
        right: 0;
    }

    .ann-table tr:nth-child(even) {
        background-color: rgb(235,237,239);
    }

    .ann-table th:nth-child(2) {
        color: white;
        font-weight: normal;
        vertical-align: middle;
        width: 177px !important;
    }

    .ann-table td .floatRight {
        float: right;
        display: -webkit-box;
        display: -ms-flexbox;
        position: -webkit-sticky;
        position: sticky;
        margin-left: 35px;
        margin-top: -14px;
    }

    .text-center {
        text-align: center;
    }

    .font12 {
        font-size: 12px;
    }

    .ann-green-bold {
        color: #297b01 !important;
        font-weight: bold !important;
    }

    .ann-red {
        color: #ef5565 !important;
    }

    .ann-underline {
        text-decoration: underline;
    }

    .ann-blue {
        color: #4464fc !important;
    }

    .ann-darkblue {
        color: #243147 !important;
    }

    .white-spaceUnset {
        white-space: unset !important;
    }

    .pointer {
        cursor: pointer;
    }

    .pin-icon {
        width: 16px;
    }

    .no-list {
        display: flex;
    }
</style>



// WEBPACK FOOTER //
// src/components/ActiveAnnoucement.vue